import rest from '../../common/services/restFootData';

// Column id (used for display/sort UI) -> FootData API order property.
// Team/competition names live in translations, so ordering goes through the translated path.
const ORDER_FIELD_BY_COLUMN: { [column: string]: string } = {
  'competition.name': 'competition.translations.name',
  'winnerTeam.name': 'winnerTeam.translations.name',
  'runnerUpTeam.name': 'runnerUpTeam.translations.name',
};

export const getAwardOrderField = (field: string): string => ORDER_FIELD_BY_COLUMN[field] || field;

export function fetchTournamentAwards(filters) {
  const params = {
    imageFilterNames: ['60x60'],
    groups: ['read_link', '_competition_award', '_tournament_award', '_team_award', '_country', '_image'],
    itemsPerPage: 10,
    partial: 0,
    // Ordering is owned by the caller (its query state). We must NOT impose a default
    // order[...] here: it is a different key from the caller's order[...] so it would not
    // be overridden, and API Platform would keep it as the primary sort -> clicking a column
    // would never visibly reorder.
    ...filters
  };

  return dispatch => {
    dispatch({ type: 'FETCH_TOURNAMENT_AWARDS' });
    return rest.get('tournament_awards', { params }).then(
      res => {
        dispatch({ type: 'FETCH_TOURNAMENT_AWARDS_FULFILLED', payload: res.data });
        // Resolve with the data so callers can consume their own response directly
        // (e.g. TeamAwards loads winner + runner-up in parallel without clobbering a shared slot).
        return res.data;
      },
      err => dispatch({ type: 'FETCH_TOURNAMENT_AWARDS_REJECTED', payload: err.response })
    );
  };
}

export function fetchTournamentAward(id) {
  const params = {
    groups: ['read_link', '_competition_award', '_tournament_award', '_team_award', '_country', '_image'],
    imageFilterNames: ['60x60'],
  };

  return dispatch => {
    dispatch({ type: 'FETCH_TOURNAMENT_AWARD' });
    return rest.get(`tournament_awards/${id}`, { params }).then(
      res => {
        dispatch({ type: 'FETCH_TOURNAMENT_AWARD_FULFILLED', payload: res.data });

        return res.data;
      },
      err => {
        dispatch({ type: 'FETCH_TOURNAMENT_AWARD_REJECTED', payload: err.response });

        throw err;
      }
    );
  };
}

export function createTournamentAward(data) {
  return dispatch => {
    dispatch({ type: 'CREATE_TOURNAMENT_AWARD' });
    return rest.post('tournament_awards', data).then(
      res => {
        dispatch({ type: 'CREATE_TOURNAMENT_AWARD_FULFILLED', payload: res.data });

        return res.data;
      },
      err => {
        dispatch({ type: 'CREATE_TOURNAMENT_AWARD_REJECTED', payload: err.response });

        throw err;
      }
    );
  };
}

export function updateTournamentAward(id, data) {
  return dispatch => {
    dispatch({ type: 'UPDATE_TOURNAMENT_AWARD' });
    return rest.put(`tournament_awards/${id}`, data).then(
      res => {
        dispatch({ type: 'UPDATE_TOURNAMENT_AWARD_FULFILLED', payload: res.data });

        return res.data;
      },
      err => {
        dispatch({ type: 'UPDATE_TOURNAMENT_AWARD_REJECTED', payload: err.response });

        throw err;
      }
    );
  };
}

export function deleteTournamentAward(id) {
  return dispatch => {
    dispatch({ type: 'DELETE_TOURNAMENT_AWARD' });
    return rest.delete(`tournament_awards/${id}`).then(
      res => {
        dispatch({ type: 'DELETE_TOURNAMENT_AWARD_FULFILLED', payload: id });

        return res;
      },
      err => {
        dispatch({ type: 'DELETE_TOURNAMENT_AWARD_REJECTED', payload: err.response });

        throw err;
      }
    );
  };
}
